export default /* css */ `
:host {
  --ui-heading-font-size: var(--ui-sys-typescale-display-large-font-size);
  --ui-heading-line-height: var(--ui-sys-typescale-display-large-line-height);
  --ui-heading-font-weight: var(--ui-sys-typescale-display-large-font-weight);
}

h1 {
  color: hsl(var(--ui-sys-color-on-surface));
  font-size: var(--ui-heading-font-size);
  line-height: var(--ui-heading-line-height);
  font-weight: var(--ui-heading-font-weight);
  margin-top: 0;
  margin-bottom: calc(var(--ui-sys-unit) * 28);
}
h2 {
  color: hsl(var(--ui-sys-color-on-surface));
  font-size: var(--ui-sys-typescale-display-medium-font-size);
  line-height: var(--ui-sys-typescale-display-medium-line-height);
  font-weight: var(--ui-sys-typescale-display-medium-font-weight);
  margin-top: 0;
  margin-bottom: calc(var(--ui-sys-unit) * 24);
}

h3 {
  color: hsl(var(--ui-sys-color-on-surface));
  font-size: var(--ui-sys-typescale-display-small-font-size);
  line-height: var(--ui-sys-typescale-display-small-line-height);
  font-weight: var(--ui-sys-typescale-display-small-font-weight);
  margin-top: 0;
  margin-bottom: calc(var(--ui-sys-unit) * 20);
}

h4 {
  color: hsl(var(--ui-sys-color-on-surface));
  font-size: var(--ui-sys-typescale-headline-large-font-size);
  line-height: var(--ui-sys-typescale-headline-large-line-height);
  font-weight: var(--ui-sys-typescale-headline-large-font-weight);
  margin-top: 0;
  margin-bottom: calc(var(--ui-sys-unit) * 16);
}

h5 {
  color: hsl(var(--ui-sys-color-on-surface));
  font-size: var(--ui-sys-typescale-headline-medium-font-size);
  line-height: var(--ui-sys-typescale-headline-medium-line-height);
  font-weight: var(--ui-sys-typescale-headline-medium-font-weight);
  margin-top: 0;
  margin-bottom: calc(var(--ui-sys-unit) * 16);
}

h6 {
  color: hsl(var(--ui-sys-color-on-surface));
  font-size: var(--ui-sys-typescale-headline-small-font-size);
  line-height: var(--ui-sys-typescale-headline-small-line-height);
  font-weight: var(--ui-sys-typescale-headline-small-font-weight);
  margin-top: 0;
  margin-bottom: calc(var(--ui-sys-unit) * 16);
}
`
